export default __webpack_public_path__ + "static/gerson-c7e971a0c84998152666623ccab0126c.jpg";